export default __webpack_public_path__ + "static/media/note.6e344d25.svg";